<template>
  <div>
    <el-carousel id="el-carousel1" style="overflow:hidden">
      <el-carousel-item v-for="(item,index) in bannerList" :key="index" class="el-carousel-item1">
        <img ref="image1" :title="item.title" :src="$imgRoot+'/'+item.image" width="100%" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        bannerList: [],
        _height: this.$store.state.width
      }
    },
    mounted() {
      var self = this;
      this.getBannerList();
      window.onresize = function () {
        self.height = self.$refs['image1'][0].height + "px";
        self.resize();
      }
    },
    methods: {
      getBannerList() {
        var self = this;
        this.$axios.get("/web/index/banner").then(res => {
          if (res.code == 0) {
            this.bannerList = res.data;
            setTimeout(() => {
              self.height = this.$refs['image1'][0].height + "px";
              self.resize();
            }, 300);
          }
        })
      },
      resize() {
        var self = this;
        document.getElementById("el-carousel1").style.height = self.height;
        let itemList = document.getElementsByClassName("el-carousel-item1")
        for (let i = 0; i < itemList.length; i++) {
          itemList[i].style.height = self.height;
        }
        document.getElementById("el-carousel1").style.height = self.height;
      }
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/index/components/banner.vue